import {
  TradeDirection,
  TradeFlow,
} from '../../graphQL/types/shared';

const getTradeLabel = (tradeDirection: TradeDirection, tradeFlow: TradeFlow): string => {
  if (tradeDirection === TradeDirection.export) {
    if (tradeFlow === TradeFlow.Gross) {
      return __lexiconText('applicationWide.monetaryValue.grossExport');
    } else {
      return __lexiconText('applicationWide.monetaryValue.netExport');

    }
  } else {
    if (tradeFlow === TradeFlow.Gross) {
      return __lexiconText('applicationWide.monetaryValue.grossImport');
    } else {
      return __lexiconText('applicationWide.monetaryValue.netImport');
    }
  }
};

export default getTradeLabel;
